module.exports = __webpack_public_path__ + "assets/down_caret.412f3289.svg";